import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import { Paths } from "../../../constants/UrlConstants";
import { connect } from "react-redux";
import { setSessionTimeout } from "../../../actions/account/accountActions";
import Button from "../../shared/buttons/Button";
import ErrorImageTimeout from "../../../assets/img/Refresh-images/ErrorImageTimeout.png";
import LOGOUT from "../../logout/Logout";
import styles from "../../../assets/css/modules/information/errors/sharedErrorContent/error-content-links.css";
import { Link } from "react-router-dom";
import { ErrorContentLinks } from "./sharedErrorContent/ErrorContentLinks";
import ErrorInformation from "../ErrorInformation";
export const mapDispatchToProps = (dispatch) => {
  return {

    setTimedOut: (value) => dispatch(setSessionTimeout(value))
  };
};
export const mapStateToTimeout = (state) => {
  return {
    layout: state && state.layoutReducer && state.layoutReducer.layout,
    isTimedOut: state && state.accountReducer && state.accountReducer.isTimedOut
  };
};
const floatLink = {
  float: "left",
  paddingTop: "10px"
};
const floatButton = {
  float: "right",
  width: "50%"
};

export class Timeout extends Component {
  constructor(props) {
    super(props);
    this.onBackClick = this.onBackClick.bind(this);
  }
  onBackClick = (event) => {

    event.preventDefault();
    if (this.props.isTimedOut) {
      this.props.setTimedOut(false);
      localStorage.clear();
      sessionStorage.clear();
      window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession(true);
    }
    this.props.history.push(Paths.HomeRoot);
  };
  // render() {
  //   return (
  //     <Information headerText={Store.ErrorPages.Timeout.HeaderText}>
  //       <Content name={Store.ErrorPages.Timeout.MessageSSO} />
  //       <div style={floatLink}>
  //         <ErrorContentLinks />
  //       </div>
  //       <div style={floatButton}>
  //         <Button
  //           label={Store.ErrorPages.Timeout.ButtonLabel}
  //           onClick={(event) => this.onBackClick(event)}
  //           buttonType="primaryOrangeButton"
  //           key="continueButton"
  //           id="continueButton"
  //         />
  //       </div>
  //     </Information>
  //   );
  // }
  render() {
    return (
      <div>
        {this.props.layout === 'MOL' ? (
          <div className="container">
        <div className="row container-row-generic">
          <div className="col-xl-7">
            <ErrorInformation headerText={Store.ErrorPages.Timeout.HeaderText}>
              <Content name={Store.ErrorPages.Timeout.MessageSSO} />
              <div style={floatLink}>
                <div className="row">
                  <div className="col-4 float-left">
                    <p className={styles.sharedErrorContent}><LOGOUT timeout="timeout"/></p>
                  </div>
                  <div className="col-3 float-right">
                    <Link to={Paths.LoggedOut}>
                      <Content name={Store.ErrorPages.Timeout.Link} />
                    </Link>
                  </div>
                </div>
              </div>
              <div>
              <div style={floatButton}>
                <Button
                  label={Store.ErrorPages.Timeout.ButtonLabel}
                  onClick={(event) => this.onBackClick(event)}
                  buttonType="primaryOrangeButton"
                  key="continueButton"
                  id="continueButton"
                />
              </div>
              </div>
            </ErrorInformation>
          </div>
          <div className="col-md-5 col-lg-5 col-sm-5 d-none d-sm-block">
          <div className="container">
            <img className="d-none d-sm-block imgtimeout" src={ErrorImageTimeout} alt="" />
          </div>
          </div>
        </div>
        </div>) : (<Information headerText={Store.ErrorPages.Timeout.HeaderText}>
          <Content name={Store.ErrorPages.Timeout.MessageSSO} />
          <div style={floatLink}>
            <ErrorContentLinks />
          </div>
          <div style={floatButton}>
            <Button
              label={Store.ErrorPages.Timeout.ButtonLabel}
              onClick={(event) => this.onBackClick(event)}
              buttonType="primaryOrangeButton"
              key="continueButton"
              id="continueButton"
            />
          </div>
        </Information>)}
      </div>
    );
  }
}
export default withRouter(
  connect(mapStateToTimeout, mapDispatchToProps)(Timeout)
);